import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Layout from "../components/Layout";
import Breadcrumbs from "../components/Breadcrumbs";
import PreFooterCTA from "../components/PreFooterCTA";
import { BUSINESS } from "../data/business";

const BREADCRUMBS = [{ label: "Privacy Policy" }];
const SCROLL_DELAY_MS = 80; // wait for layout before scrolling to the anchor

function scrollToHash(hash) {
  if (!hash) return undefined;
  const targetId = hash.replace("#", "");
  const timer = setTimeout(() => {
    const target = document.getElementById(targetId);
    if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
  }, SCROLL_DELAY_MS);
  return () => clearTimeout(timer);
}

export default function Privacy() {
  const { hash } = useLocation();
  useEffect(() => scrollToHash(hash), [hash]);
  return (
    <Layout>
      <section className="abc-bg-pale">
        <div className="abc-container py-12 md:py-16 max-w-4xl">
          <Breadcrumbs items={BREADCRUMBS} />
          <h1 className="font-display mt-4 text-3xl sm:text-4xl font-extrabold text-[#1A1D21]">Privacy Policy</h1>
          <p className="text-sm text-slate-500 mt-2">Last updated: November 2025</p>

          <div className="mt-8 prose prose-slate max-w-none text-slate-700 leading-relaxed space-y-4">
            <h2 className="font-display text-2xl font-bold text-[#1A1D21]">Information We Collect</h2>
            <p>When you submit a contact form, request a quote, or call us, we may collect your name, phone number, email, address, and details about the plumbing issue you're describing.</p>

            <h2 className="font-display text-2xl font-bold text-[#1A1D21]">How We Use Your Information</h2>
            <p>We use your information to respond to your inquiry, schedule and complete your service, and follow up about your job. We do not sell your information.</p>

            <h2 className="font-display text-2xl font-bold text-[#1A1D21]">SMS / Text Messaging</h2>
            <p>If you give us your phone number, you consent to receive transactional and service-related SMS from {BUSINESS.name}. Message and data rates may apply. Frequency varies. Reply <strong>STOP</strong> to opt out at any time. Reply <strong>HELP</strong> for help. <strong>We do not share your mobile information or SMS consent with third parties or affiliates for marketing purposes.</strong></p>

            <h2 className="font-display text-2xl font-bold text-[#1A1D21]">Phone Numbers</h2>
            <p>Phone numbers collected via our website are used only to contact you about your service inquiry. They are not sold, traded, or used for unrelated marketing.</p>

            <h2 id="cookies" className="font-display text-2xl font-bold text-[#1A1D21] scroll-mt-28">Cookies</h2>
            <p>We use minimal cookies for site functionality and basic analytics. You can disable cookies in your browser settings.</p>

            <h2 className="font-display text-2xl font-bold text-[#1A1D21]">Opt-Out</h2>
            <p>To opt out of communications, reply STOP to any text from us, click unsubscribe on any email, or contact us directly.</p>

            <h2 className="font-display text-2xl font-bold text-[#1A1D21]">Your Rights</h2>
            <p>You may request a copy of the information we have about you, or ask us to delete it. Email <a href={BUSINESS.emailHref} className="text-[#54616E] underline hover:text-[#1A1D21]">{BUSINESS.email}</a> to make a request.</p>

            <h2 className="font-display text-2xl font-bold text-[#1A1D21]">Contact</h2>
            <p>Questions? Email <a href={BUSINESS.emailHref} className="text-[#54616E] underline hover:text-[#1A1D21]">{BUSINESS.email}</a> or call <a href={BUSINESS.phoneHref} className="text-[#54616E] underline hover:text-[#1A1D21]">{BUSINESS.phone}</a>.</p>
          </div>
        </div>
      </section>
      <PreFooterCTA />
    </Layout>
  );
}
